import { FC, useEffect, useState } from 'react';
import { AlphabetItem } from '../alphabetItem/alphabetItem';
import { TItem } from '../types';

interface AlphabeticalItemProps {
	item: TItem;
	prevItem: TItem | null;
	onSelect?: (item: TItem) => void;
}

export const AlphabeticalItem: FC<AlphabeticalItemProps> = ({
	item,
	prevItem,
	onSelect,
}) => {
	const [alphabet, setAlphabet] = useState('');

	useEffect(() => {
		const alphabetName = item.name.charAt(0).toUpperCase();
		if (!prevItem) {
			setAlphabet(alphabetName);
			return;
		}

		const alphabetPrevItemName = prevItem.name.charAt(0).toUpperCase();

		if (alphabetName !== alphabetPrevItemName) {
			setAlphabet(alphabetName);
		}
	}, [item, prevItem]);

	return (
		<AlphabetItem
			alphabetSymbol={
				alphabet ? alphabet : item.name.charAt(0).toUpperCase()
			}
			item={item}
			hideSymbol={!alphabet}
			onSelect={onSelect}
		/>
	);
};
